

import api from '../../../api/clinique/_assurances'

const state = () => ({
    assurances: [],
    souscripteurs: [],
    facture_rembours: [],

    groupe_assur_actif: [],
    info_patient_assure: [],
})

// getters
const getters = {
    assurances: (state) => {
        return state.assurances
    },

    // Liste des souscripteur appartenant à une assurance
    souscripteurs: (state) => {
        return state.souscripteurs
    },

    facture_rembours: (state) => {
        return state.facture_rembours
    },

    groupe_assur_actif: (state) => {
        return state.groupe_assur_actif
    },

    info_patient_assure: (state) => {
        return state.info_patient_assure
    },
}
// mutations
const mutations = {
    SET_ASSURANCES(state, assur) {
        state.assurances = assur
    },

    SET_SOCIETE_BY_ASSURANCES(state, souscripteurs) {
        state.souscripteurs = souscripteurs
    },

    SET_FACTURE_REMBOURSE(state, facture) {
        state.facture_rembours = facture
    },

    SET_GROUPE_ASSUR_ACTIF(state, groupe) {
        state.groupe_assur_actif = groupe
    },

    SET_INFO_PATIENT_ASSURE(state, info) {
        state.info_patient_assure = info
    },
}

// actions
const actions = {
    
    getAssurances({ commit }) {
        return new Promise((resolve, reject) => {
            api.getAssurances().then(
                response => {
                    commit('SET_ASSURANCES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },

    getSocieteByAssurance({ commit }, assurance_id) {
        return new Promise((resolve, reject) => {
            api.getSocieteByAssurance(assurance_id).then(
                response => {
                    resolve(response)
                    commit('SET_SOCIETE_BY_ASSURANCES', response)

                }, error => {
                    reject(error)
                }
            )
        })
    },

    getFactureRembourse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getFactureRembourse(data).then(
                response => {
                    commit('SET_FACTURE_REMBOURSE', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },

    getGroupeAssuranceActif({ commit }) {
        return new Promise((resolve, reject) => {
            api.getGroupeAssuranceActif().then(
                response => {
                    commit('SET_GROUPE_ASSUR_ACTIF', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },

    getInfoPatientAssure({ commit }, patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoPatientAssure(patient_id).then(
                response => {
                    commit('SET_INFO_PATIENT_ASSURE', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })  
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}


